export const getMenuData = [
  {
    title: 'Overzicht',
    key: 'dashboard',
    userType: 'driver',
    icon: 'fe fe-grid',
    url: '/overzicht',
  },
  {
    title: 'Nieuwe Reservering',
    key: 'nieuwe-reservering',
    userType: 'admin',
    icon: 'fe fe-plus',
    url: '/nieuwe-reservering',
  },
  {
    title: 'Prijzen',
    key: 'prijzen',
    userType: 'admin',
    icon: 'fe fe-tag',
    children: [
      {
        title: 'Kortingen',
        key: 'kortingen',
        userType: 'admin',
        url: '/kortingen',
      },
      {
        title: 'Prijstabellen',
        key: 'prijstabellen',
        userType: 'admin',
        url: '/prijstabellen',
      },
    ],
  },

  {
    title: 'Organisaties',
    key: 'organisaties',
    userType: 'admin',
    icon: 'fe fe-briefcase',
    url: '/organisaties',
  },
  {
    title: 'Facturen',
    key: 'facturen',
    userType: 'admin',
    icon: 'fe fe-file-text',
    url: '/facturen',
  },
  {
    title: 'Boekhouding',
    key: 'bookkeeping',
    userType: 'admin',
    icon: 'fe fe-dollar-sign',
    url: '/boekhouding',
  },
  {
    title: 'Chauffeurs',
    key: 'chauffeurs',
    userType: 'admin',
    icon: 'fe fe-users',
    url: '/chauffeurs',
  }
]
